import { initLazy } from './lazyload';
import { pagination } from './pagination'

export const utility = () => {

    initLazy.init();
    pagination.init();

}